// String ids shared with utils/constants.js. This file has no app imports so
// node:test can load lead-form helpers that depend on the same values.
export const META = "meta";
export const TIKTOK = "tiktok";
export const GOOGLE = "google";
export const LINKEDIN = "linkedIn";

export const ADS_CAMPAIGN_OBJECTIVE_LEADS_OPTION = "leads";

export const ADS_CAMPAIGN_META_DESTINATION_TYPE_WEBSITE_OPTION = "WEBSITE";
export const ADS_CAMPAIGN_META_DESTINATION_TYPE_LEAD_INSTANT_FORM_OPTION =
  "ON_AD";
